module.exports = __webpack_public_path__ + "static/media/aerial2blur.a436d1a1.jpg";